export default {
  // Hero Section
  hero: {
    title: 'Features',
    subtitle: 'Explore all the powerful features we offer for you and your pets'
  },
  
  // Status Badges
  status: {
    available: 'Available',
    beta: 'Beta'
  },
  
  // Core Features Section
  core: {
    badge: 'Core Features',
    title: 'Essential Tools',
    description: 'These are the fundamental features that make pet care simple and effective',
    
    petProfiles: {
      title: 'Pet Profiles',
      description: 'Create complete digital profiles for each pet with all important information',
      feature1: 'Comprehensive Information',
      feature2: 'Photo Upload',
      feature3: 'Medical Records',
      feature4: 'Behavior Notes'
    },
    
    secureSharing: {
      title: 'Secure Sharing',
      description: 'Securely share pet information with authorized people through encrypted links',
      feature1: 'Unique Share Links',
      feature2: 'Read-Only Access',
      feature3: 'No Login Required',
      feature4: 'Privacy Protected'
    },
    
    schedule: {
      title: 'Schedule Management',
      description: 'Set and track feeding, medication, and activity schedules',
      feature1: 'Feeding Schedules',
      feature2: 'Medication Reminders',
      feature3: 'Exercise Tracking',
      feature4: 'Vet Appointments'
    },
    
    healthTracking: {
      title: 'Health Tracking',
      description: 'Monitor your pet\'s health metrics and medical history',
      feature1: 'Weight Tracking',
      feature2: 'Vaccination History',
      feature3: 'Allergy Management',
      feature4: 'Vet Records'
    },
    
    mobileFriendly: {
      title: 'Mobile Friendly',
      description: 'Responsive design that works perfectly on any device',
      feature1: 'Responsive Design',
      feature2: 'Touch Optimized',
      feature3: 'Cross-Platform',
      feature4: 'Offline Data Cache'
    },
    
    multiLanguage: {
      title: 'Multi-Language Support',
      description: 'Support for Traditional Chinese, English, and Japanese interfaces',
      feature1: 'Chinese Support',
      feature2: 'English Support',
      feature3: 'Japanese Support',
      feature4: 'Instant Language Switch'
    }
  },
  
  // Advanced Features Section
  advanced: {
    badge: 'Advanced Features',
    title: 'Powerful Tools',
    description: 'Professional features for advanced users',
    
    security: {
      title: 'Enhanced Security',
      description: 'Industry-standard encryption protects your pet data, ensuring only authorized users can access it'
    },
    
    multiUser: {
      title: 'Multi-User Access',
      description: 'Allow multiple family members or caregivers to view pet information simultaneously and participate in care together'
    },
    
    editing: {
      title: 'Full Editing Feature',
      description: 'Update pet information anytime, including photos, medical records, and schedules'
    },
    
    cloudSync: {
      title: 'Cloud Sync',
      description: 'Automatically sync to the cloud, ensuring data safety and accessibility from any device'
    },
    
    location: {
      title: 'Location Tracking',
      description: 'Record your pet\'s current location and vet clinic information for emergency situations'
    },
    
    performance: {
      title: 'Performance Optimization',
      description: 'Fast loading and smooth user experience, even when managing multiple pets'
    }
  },
  
  // Coming Soon Section
  upcoming: {
    badge: 'Coming Soon',
    title: 'Upcoming Features',
    description: 'We\'re developing more exciting features, stay tuned',
    
    notifications: {
      title: 'Smart Notifications',
      description: 'Receive smart reminders based on your pet\'s schedule, never miss important tasks'
    },
    
    backup: {
      title: 'Auto Backup & Restore',
      description: 'Automatically backup your pet data and restore to previous versions anytime'
    },
    
    calendar: {
      title: 'Calendar Integration',
      description: 'Sync with your calendar app to add pet activities to your daily schedule'
    },
    
    community: {
      title: 'Community Feature',
      description: 'Exchange experiences with other pet owners and share care tips'
    },
    
    healthTrends: {
      title: 'Health Trend Analysis',
      description: 'Analyze your pet\'s health trends through charts and reports, detect issues early'
    },
    
    vetIntegration: {
      title: 'Vet Clinic Integration',
      description: 'Connect directly with vet clinic systems to automatically sync medical records'
    }
  },
  
  // CTA Section
  cta: {
    title: 'Ready to Explore All Features?',
    subtitle: 'Start using these powerful features now to make pet care easier'
  }
};